import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const Navbar = ({ errorMessage, setShiftNoteFormVisible, setAddGuestFormVisible }) => {
  const { t } = useTranslation(['action-log'])
  return (
    <div className={`ctp-action-log-navbar`}>
      <div className="shift-note-button">
        <button className="button button-primary" onClick={() => setShiftNoteFormVisible(true)}>
          {t('action-log:navbar.createNoteButton')}
        </button>
      </div>
      <div className="shift-note-button">
        <button className="button button-primary" onClick={() => setAddGuestFormVisible(true)}>
          {t('action-log:navbar.addGuestButton')}
        </button>
      </div>
      <div className="ctp-packages-navbar__error-message">{errorMessage}</div>
    </div>
  )
}

Navbar.propTypes = {
  errorMessage: PropTypes.string,
  setShiftNoteFormVisible: PropTypes.func,
  setAddGuestFormVisible: PropTypes.func,
}

export default Navbar
